<svelte:options runes={true} />
<script lang="ts">import Progress from "../components/Progress.svelte";
import Button from "../components/Button.svelte";
import BackIcon from "../components/icon/Back.svelte";
import ClickDimensionsForm from "./ClickDimensionsForm.svelte";
import SvelteMarkdown from "../compat/SvelteMarkdown.svelte";
import { AssessmentNode, AssessmentNodeType, } from "./models/AssessmentNode";
import { fade } from "svelte/transition";
import { onMount } from "svelte";
import { defaults } from "./data/selfAssessmentDefaultOptions";
import { filterObject } from "../util/object";
import { getScrollParent } from "../util/dom";
import ClickDimensionsAdviceForm from "./ClickDimensionsAdviceForm.svelte";
const options = Object.assign({}, defaults, filterObject(window.satOptions || {}));
let { node = null } = $props();
const emptyNode = new AssessmentNode();
let rootNode = $state(emptyNode);
let currentNode = $state(emptyNode);
let qnas = $state([]);
let loading = $state(true);
let container = $state(null);
let debug = $state({});
let selectedLang = $state("sv");
let showThanks = $state(false);
const langs = ["sv", "dk"];
let levels = $derived((currentNode === null || currentNode === void 0 ? void 0 : currentNode.getMaxDepth(true)) || 0);
let title = $derived((currentNode === null || currentNode === void 0 ? void 0 : currentNode.title) || (rootNode === null || rootNode === void 0 ? void 0 : rootNode.title));
let progress = $derived((currentNode === null || currentNode === void 0 ? void 0 : currentNode.getAscent()) || 0);
let nextNode = $derived(currentNode.children[0]);
$effect(() => {
    if (options.debug) {
        if (currentNode.children.length !== 1 &&
            currentNode.type !== AssessmentNodeType.Redirect) {
            debug = {};
        }
        else {
            if (currentNode.type === AssessmentNodeType.Redirect) {
                const { url } = currentNode;
                debug = { type: "Redirect", url };
            }
            else {
                const result = currentNode.children[0];
                const { price, title, preamble, question, text } = result;
                debug = { title, price, preamble, text, question };
            }
        }
    }
});
$effect.pre(() => {
    if (node && node !== rootNode) {
        rootNode = node;
        currentNode = node;
        loading = false;
    }
});
$effect(() => {
    if (container === null)
        return;
    const scrollContainer = getScrollParent(container);
    if (scrollContainer &&
        scrollContainer.scrollTop > container.offsetTop) {
        scrollContainer.scrollTop = container.offsetTop;
    }
});
function handleNodeChoice(v) {
    const eventNode = v;
    let chosenNode = eventNode;
    if (chosenNode.type === AssessmentNodeType.Reference &&
        chosenNode.parent !== null) {
        chosenNode = chosenNode.parent.children[chosenNode.index];
    }
    if (chosenNode.type === AssessmentNodeType.Redirect &&
        !!chosenNode.url &&
        !options.debug) {
        window.location.href = chosenNode.url;
        return;
    }
    if (currentNode.type === AssessmentNodeType.Question) {
        qnas = [...qnas, currentNode.question, eventNode.answer];
    }
    if (!!window.dataLayer) {
        if (currentNode.type === AssessmentNodeType.Question) {
            window.dataLayer.push({
                event: "selfAssessmentAnswer",
                question: currentNode.question,
                answer: chosenNode.answer,
            });
        }
        if (chosenNode.eventName && chosenNode.eventValue) {
            window.dataLayer.push({
                event: chosenNode.eventName,
                [chosenNode.eventValueName || "value"]: chosenNode.eventValue,
            });
        }
    }
    currentNode = chosenNode;
}
function handleBack() {
    // remove previous question and answer
    qnas.splice(qnas.length - 2, 2);
    qnas = [...qnas];
    currentNode = currentNode.parent || currentNode;
}
function onSuccess() {
    const nextNode = currentNode.children[0];
    if (nextNode.type === AssessmentNodeType.Redirect && !!nextNode.url) {
        window.location.href = nextNode.url;
        return;
    }
    else if (options.gated &&
        currentNode.type === AssessmentNodeType.Form &&
        nextNode.type === AssessmentNodeType.Result) {
        showThanks = true;
        return;
    }
    currentNode = nextNode;
}
function createNode(c) {
    return new AssessmentNode(Object.assign(Object.assign({}, c), { children: c.children && c.children.map(createNode) }));
}
async function loadJson(url) {
    if (node)
        return;
    const res = await fetch(url || options.jsonUrl);
    if (res.ok) {
        const json = await res.json();
        const loadedNode = createNode(json);
        currentNode = loadedNode;
        rootNode = loadedNode;
    }
    qnas = [];
    debug = {};
    loading = false;
}
onMount(loadJson);
function handleLangChange() {
    loading = true;
    loadJson(`/json/sat.${selectedLang}.json`);
}
</script>

<div bind:this={container} class="self-assessment-block-container">
	{#if !loading}
		{#if options.gated && nextNode?.type === AssessmentNodeType.Result && currentNode.type === AssessmentNodeType.Form}
			<div id="flex-row-wrapper" class="tp_flex tp_flex-row">
				<div in:fade class="tp_flex tp_flex-row">
					<div class="self-assessment-block-item result">
						<div class="row result-price">
							<h1>
								{nextNode.price?.split("/")[0]} /
								<span class="month"
									>{nextNode.price?.split("/")[1]}</span
								>
							</h1>
						</div>
						<div class="row result-price">
							<h3>{nextNode.preamble}</h3>
						</div>
						<div class="row result-price">
							<h2>{nextNode.title}</h2>
						</div>
						<div class="row result-price">
							<SvelteMarkdown source={nextNode.text} />
						</div>
					</div>
					{#if !showThanks}
						<div class="CD_advice_container">
							<ClickDimensionsAdviceForm
								{options}
								{onSuccess}
								{qnas}
							/>
						</div>
					{:else}
						<div class="show-thanks">
							<SvelteMarkdown source={options.sendSuccessText} />
						</div>
					{/if}
				</div>
			</div>
		{:else if currentNode.type === AssessmentNodeType.Result}
			<div in:fade class="self-assessment-block-item result">
				<div class="row">
					<h1>
						{currentNode.price?.split("/")[0]} /
						<span class="month"
							>{currentNode.price?.split("/")[1]}</span
						>
					</h1>
				</div>
				<div class="row">
					<h3>{currentNode.preamble}</h3>
				</div>
				<div class="row">
					<h2>{currentNode.title}</h2>
				</div>
				<div class="row">
					<SvelteMarkdown source={currentNode.text} />
				</div>
			</div>
		{:else}
			<div class="self-assessment-block-item">
				<div class="row">
					{#key title}
						<h2 in:fade>{title}</h2>
					{/key}
				</div>
				<div class="row">
					<Progress max={levels} value={progress} />
				</div>
				<div class="row">
					{#key currentNode.question}
						<h3 in:fade class="question">
							{currentNode.question}
						</h3>
					{/key}
				</div>
				{#if currentNode.type === AssessmentNodeType.Form}
					<div class="row">
						<ClickDimensionsForm {options} {onSuccess} {qnas} />
					</div>
				{:else}
					<div class="row">
						{#each currentNode.children as child}
							<div class="option">
								<Button
									onclick={(v) => handleNodeChoice(v)}
									value={child}
									text={child.answer}
								/>
							</div>
						{/each}
					</div>
				{/if}
				<div class="row">
					{#if (currentNode.parent !== null && currentNode.children.length !== 0) || currentNode.type === AssessmentNodeType.Redirect}
						<button class="back" onclick={handleBack}>
							<BackIcon />
							<span>{options.backText}</span>
						</button>
					{/if}
				</div>
			</div>
		{/if}
	{/if}
	{#if options.debug}
		<div>
			<select bind:value={selectedLang} onchange={handleLangChange}>
				{#each langs as lang}
					<option value={lang}>
						{lang}
					</option>
				{/each}
			</select>
			<pre>
      {qnas.join("\n")}
        {#if !!debug}
					{JSON.stringify(debug, null, 2)}
				{/if}
      </pre>
		</div>
	{/if}
</div>

<style lang="scss">:global(html) {
  scroll-behavior: smooth;
}

:global(.self-assessment-block-container a) {
  color: #ffffff !important;
  text-decoration: underline;
}

.self-assessment-block-container {
  display: flex;
  flex-direction: column;
  background-color: #0a1f2e;
  background-image: url("/images/brand/NBP_Perspective_9_RGB_1.png");
  background-position: bottom center;
  background-size: cover;
  background-repeat: no-repeat;
  color: #ffffff;
  min-height: 480px;
  margin: 1.5rem 0;
  padding: 4rem 3rem;
  box-sizing: border-box;
}
.self-assessment-block-container > * {
  box-sizing: border-box;
}
.self-assessment-block-container .tp_flex {
  display: flex;
}
.self-assessment-block-container #flex-row-wrapper {
  max-width: 1676px;
}
.self-assessment-block-container .tp_flex-row {
  flex-direction: row;
}
@media screen and (max-width: 980px) {
  .self-assessment-block-container .tp_flex-row {
    flex-direction: column;
  }
}

.self-assessment-block-item {
  max-width: 1600px;
  margin: auto auto;
  text-align: center;
  flex: 1 1 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.self-assessment-block-item h3,
.self-assessment-block-item h2 {
  margin-bottom: 2rem;
}
.self-assessment-block-item .result-price {
  display: flex;
  justify-content: flex-start;
  text-align: start;
}
.self-assessment-block-item .result-price h1 {
  font-size: var(--font__size--36);
  font-family: var(--font__bold);
}
.self-assessment-block-item .result-price span {
  font-size: var(--font__size--24);
}

.CD_advice_container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-width: 415px;
  margin-left: 1rem;
  width: 415px;
}
@media screen and (max-width: 980px) {
  .CD_advice_container {
    width: auto;
    min-width: auto;
    margin-top: 1rem;
  }
}

:global(.self-assessment-block-item.result p) {
  max-width: 1005px;
  font-size: var(--font__size--24);
}

span.month {
  font-size: var(--font__size--24);
  font-family: var(--font__light);
}

.back {
  display: flex;
  align-items: center;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.back span {
  margin-left: 0.5rem;
  text-decoration: underline;
}

h3.question {
  margin-top: 1rem;
  font-family: var(--font__regular);
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
@media screen and (max-width: 980px) {
  .row {
    margin-bottom: 1rem;
  }
}
.row:not(:last-child) {
  margin-bottom: 1rem;
}
.row .option {
  margin: 0 1rem 1rem 0;
}

pre {
  max-width: 500px;
}

.show-thanks {
  min-width: 415px;
  width: 415px;
}</style>
